import { Component, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-exchange-code',
  templateUrl: './exchange-code.component.html',
  styleUrls: ['./exchange-code.component.scss'],
})
export class ExchangeCodeComponent {
  @Input() text = '';
  @Input() coverText = '点击查看兑换码';
  isVisible = false;

  constructor(private clipboard: Clipboard, private message: MessageService) {}

  copy() {
    this.clipboard.copy(this.text);
    this.message.open('兑换码已复制');
  }
}
